import dayjs from 'dayjs'
import { OCCUPATIONAL_THERAPIST_NOTES_CONSTANT_ENTRY,   OCCUPATIONAL_THERAPIST_NOTES_CONSTANT_ENTRY_INITIAL_VALUES} from '../../../Notes/Occupational_therapy/OCCUPATIONAL_THERAPIST_NOTES_CONSTANT'
import React, {useState, useEffect} from 'react'
import axios from 'axios'
import {MoonLoader} from 'react-spinners'
import FormWrapper from '../../../../reusable-components/Wrapper/Wrapper'
import {Box, Typography} from '@mui/material'
import BackButton from '../../../../reusable-components/Buttons/BackButton'
import DynamicForm from '../../../../reusable-components/forms/DynamicForm'
import {useSelector} from 'react-redux'
import {useHistory, useParams} from 'react-router-dom'
import { RootState } from '../../../../../setup'
import FrequencyDateRangePicker from '../../../../reusable-components/NoteType/NoteType'
const selectTimeZone = (state: RootState) => state.timeZone.timeZone
const OccupationalTherapyNoteForm = () => {
  const [formData, setFormData] = useState(OCCUPATIONAL_THERAPIST_NOTES_CONSTANT_ENTRY_INITIAL_VALUES)
  const [uiElements, setUIElements] = useState([])
  const [loading, setLoading] = useState(false)

  const selectAuth = (state: {auth: any}) => state.auth
  const auth = useSelector(selectAuth)
  const {id}: {id: string} = useParams()
  const history = useHistory()
  const timeZone = useSelector(selectTimeZone)
const [clientid, setClientId] = useState<string | null>(null)

 useEffect(() => {
    const fetchNoteEntry = async () => {
      try {
        setLoading(true)
        
        const responseForNote = await axios.get(`/otProgressNotesEntry/getById/${id}`, {
          params: {
            isDeleted: true, 
          }
        });
        
        const {result: noteData} = responseForNote?.data;
        
        const clientOption = {
          label: noteData.clientFullName, 
          value: noteData.clientId
        };
        
        const updatedclients = [clientOption];
        
        setClientId(noteData.clientId);
        
        const formattedStartDate = dayjs.utc(noteData.startDate).tz(timeZone, true)
        const formattedEndDate = dayjs.utc(noteData.endDate).tz(timeZone, true)
        const selectedClient = updatedclients.find((client) => client.value === noteData.clientId)
        
        const updatedFormData = OCCUPATIONAL_THERAPIST_NOTES_CONSTANT_ENTRY().map((item) => {
          if (item.name === 'clientId') {
            return {
              ...item,
              options: updatedclients,
              value: selectedClient.value,
              disabled: true, 
            }
          }
          return {
            ...item,
            disabled: true,  
          };
        });
        
        const updatedData = {
          ...noteData,
          startDate: formattedStartDate,
          endDate: formattedEndDate,
          clientId: noteData.clientId, 
          occupationGoals: noteData.occupationGoals,
          performanceAreas: noteData.performanceAreas,
          performanceAreaDetails: noteData.performanceAreaDetails,
          occupationGoalsDetails: noteData.occupationGoalsDetails,
          noteType: noteData.noteType,
          addrInfo: noteData.location,
        };
        
        setFormData(updatedData)
        setUIElements(updatedFormData)
      } catch (error) {
        console.error('Error fetching note entry:', error);
      } finally {
        setLoading(false)
      }
    }
    
    fetchNoteEntry();
  }, [id])
  const buttons = [
    {
      label: 'Cancel',
      variant: 'outlined',
      type: 'button',
    },
  ]

  return (
    <>
      {loading ? (
        <div className='overlay d-flex justify-content-center' style={{marginTop: '100px'}}>
          <MoonLoader color='#9db2fc' size={60} loading={loading} />
        </div>
      ) : (
        <FormWrapper
          title='Deleted OT Note'
          content={
            <>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  alignItems: 'center',
                  marginRight: '0.5rem',

                }}
              > 
                  <BackButton />
              </Box>
              <Typography
                sx={{
                  fontSize: '16px',
                  fontWeight: 'bold',
                  marginBottom: '0.5rem',
                  marginLeft: '1rem',
                }}
                  color='primary'
                >
                  Note Type
              </Typography>
          <FrequencyDateRangePicker
            isEntry = {true}
            isTemplate = {false}
            isFullForm = {false}
            isEdit = {true}
            formData={formData}
            setFormData={setFormData}
            isDeleted={true}
                  />
              <DynamicForm
                fields={uiElements}
                data={formData}
                onSubmit={() => {}}
                buttons={buttons}
                setFormValues={setFormData}
              />
            </>
          }
        />
      )}
    </>
  )
}

export default OccupationalTherapyNoteForm